import styled, { keyframes } from 'styled-components'

export const InputActivate = keyframes`
  0% {
    background-color: var(--aliceBlue);
    border: 2px solid var(--aliceBlue);
    padding: 23px 24px 24px 23px;
    -webkit-box-shadow: 0px 0px 0px 0px var(--shadowPrimary);
    -moz-box-shadow: 0px 0px 0px 0px var(--shadowPrimary);
    box-shadow: 0px 0px 0px 0px var(--shadowPrimary);
  }
  100% {
    background-color: var(--aliceBlueLight);
    border-width: 0px;
    border-left: 4px solid var(--primary);
    padding: 23px 17.6px 24px 17.6px;
    -webkit-box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
    -moz-box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
    box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
  }
`

export const InputDeactivate = keyframes`
  0% {
    background-color: var(--aliceBlueLight);
    border-width: 0px;
    border-left: 4px solid var(--primary);
    padding: 23px 17.6px 24px 17.6px;
    -webkit-box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
    -moz-box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
    box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
  }
  100% {
    background-color: var(--aliceBlue);
    border: 2px solid var(--aliceBlue);
    padding: 23px 24px 24px 23px;
    -webkit-box-shadow: 0px 0px 0px 0px var(--shadowPrimary);
    -moz-box-shadow: 0px 0px 0px 0px var(--shadowPrimary);
    box-shadow: 0px 0px 0px 0px var(--shadowPrimary);
  }
`

export const LabelToTop = keyframes`
  0% {
    top: 25px;
  }
  100% {
    top: 8px;
    text-transform: uppercase;
  }
`

export const LabelToCenter = keyframes`
  0% {
    top: 8px;
    text-transform: uppercase;
  }
  100% {
    top: 25px;
    text-transform: none;
  }
`

export const LoginInput = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  
  background-color: var(--aliceBlue);
  border: 2px solid var(--aliceBlue);

  padding: 23px 24px 24px 23px;
  min-height: 63px;
  max-height: 63px;
  min-width: 280px;

  animation: ${InputDeactivate} .3s;
  transition: border .3s;

  @media (max-width: 1050px) {
    min-width: 100%;
    width: 100%;
  }

  &.active {
    background-color: var(--aliceBlueLight);
    border-width: 0px;
    border-left: 4px solid var(--primary);

    padding: 23px 17.6px 16.9px 17.6px;

    -webkit-box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
    -moz-box-shadow: 0px 10px 50px 0px var(--shadowPrimary);
    box-shadow: 0px 10px 50px 0px var(--shadowPrimary);

    animation: ${InputActivate} .3s;
  }

  &.active input:-webkit-autofill {
    -webkit-text-fill-color: var(--textDark) !important;
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: transparent !important;
  }

  > input:-webkit-autofill,
  > input:-webkit-autofill:hover, 
  > input:-webkit-autofill:focus,
  > textarea:-webkit-autofill,
  > textarea:-webkit-autofill:hover,
  > textarea:-webkit-autofill:focus,
  > select:-webkit-autofill,
  > select:-webkit-autofill:hover,
  > select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  &.borderDanger {
    border: 2px solid var(--danger) !important;
  }

  > label {
    position: absolute;
    top: 25px;

    font-size: 0.625rem;

    color: var(--textDark);

    animation: ${LabelToCenter} .3s;
    pointer-events: none;
  }

  &.active label {
    top: 8px;

    text-transform: uppercase;

    animation: ${LabelToTop} .3s;
  }

  > input {
    background-color: transparent;
    border: 1px solid transparent;

    font-size: 0.75rem;

    color: transparent;
  }

  &.active input {
    margin-top: 7px;
    color: var(--textDark);
  }

  &.disabled input {
    pointer-events: none;
    display: none;
  }

  &:first-child {
    margin-bottom: 4vh;
  }
`
